import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import {MdAttachFile, MdDeleteForever} from "react-icons/md";
import IconButton from "@material-ui/core/IconButton";
import {deleteBlobFile, findBoardFiles} from "../../lib/api/file";
import {useRecoilValue} from "recoil";
import {
    userState
} from "../../state/globalState";
import Typography from "@material-ui/core/Typography";


const useStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: "solid 1px #ededed",
        borderRadius: "10px",
        marginTop: "5px",
        backgroundColor: "#d9ecff",
    },
    fileItemWrapper: {
        display: "flex",
        alignItems: "center",
    }
}));

const QuestionDropzoneFileItem = ({brdNo, setQuestionFiles, ...props}) => {
    const userInfo = useRecoilValue(userState);
    const { fileUuid, bizFileSeq, fileSeq, fileNm, kognrFileGcd } = props;
    const classes = useStyles();

    const getFiles = async (admnNo, stdYear) => {
        const { data } = await findBoardFiles(admnNo, stdYear);
        if (data.success) {
            const files = data.payload;
            setQuestionFiles(files);
        }
    }

    const deleteFile = () => {
        deleteBlobFile(fileUuid, bizFileSeq, fileSeq, "hc056003").then((res) => {
            const { data } = res;
            if (data.success) {
                getFiles(brdNo, userInfo.stdYear);
            }
        });
    }

    return (
        <div className={classes.container}>
            <div className={classes.fileItemWrapper}>
                <MdAttachFile size={24} />
                <Typography variant="body1" color="textPrimary">
                    {fileNm}
                </Typography>
            </div>
            <IconButton aria-label="file-delete" onClick={deleteFile}>
                <MdDeleteForever size={24} color="#f74200" />
            </IconButton>
        </div>
    )
};

export default QuestionDropzoneFileItem;
